import type { Policy } from '@mls-wallet/shared-types';
import { AddressBookSelectorDialog } from '@/components/shared/address-book-selector-dialog';

interface RecipientSelectorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedAddress?: string | null;
  onAddressSelect: (address: string, label: string) => void;
  policy: Policy;
}

export function RecipientSelectorDialog({
  open,
  onOpenChange,
  selectedAddress,
  onAddressSelect,
  policy,
}: RecipientSelectorDialogProps): React.ReactElement {
  const allowedAddresses =
    policy.transactionType === 'TOKEN_TRANSFER' && policy.tokenTransferCondition
      ? policy.tokenTransferCondition.destinationAddresses || []
      : [];

  return (
    <AddressBookSelectorDialog
      open={open}
      onOpenChange={onOpenChange}
      mode="single"
      title="Select a Recipient"
      allowedAddresses={allowedAddresses}
      onAddressSelect={onAddressSelect}
      selectedAddress={selectedAddress}
    />
  );
}
